import { CallCard, PhoneLink } from "../components/PhoneCTA";
import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "react-router-dom";
import SEO from "../components/SEO";
import Breadcrumbs from "../components/Breadcrumbs";

const answers = [
  "Appointments and scheduling",
  "Treatment options and pathways",
  "Bloodwork and laboratory questions",
  "Clinic locations",
  "Telehealth consultations",
];

export default function Contact() {
  return (
    <div data-testid="contact-page">
      <SEO
        title="Contact Medical Peptides & VidaVital Medical"
        description="Speak with a VidaVital Medical care coordinator about peptide therapy options, bloodwork, telehealth scheduling, and clinic locations. Call (888) 773-8677."
        path="/contact"
        breadcrumbs={[{ name: "Contact", path: "/contact" }]}
      />
      <section className="vv-hero">
        <div className="vv-container py-16">
          <Breadcrumbs items={[{ name: "Contact", path: "/contact" }]} />
          <div className="vv-hero-eyebrow mb-2">Contact</div>
          <h1 className="font-display text-4xl md:text-5xl">We&apos;re here to help.</h1>
          <p className="mt-4 text-stone-600 max-w-2xl">Speak with a VidaVital Medical care coordinator about treatment options, bloodwork, or scheduling.</p>
        </div>
      </section>

      <section className="vv-container py-14 grid md:grid-cols-3 gap-6">
        <div className="md:col-span-2 space-y-6">
          <CallCard
            location="contact_page"
            title="Call Us"
            subtitle="Our patient care coordinators are available during business hours to answer any questions you have."
            tone="dark"
            testId="contact-call-card"
          />

          <div className="vv-card p-8">
            <h2 className="font-display text-2xl">Available to answer questions about</h2>
            <ul className="mt-4 space-y-2 text-stone-700">
              {answers.map((a) => (
                <li key={a} className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[color:var(--vv-teal)]"></span> {a}
                </li>
              ))}
            </ul>
          </div>

          <div className="vv-card p-8">
            <h2 className="font-display text-2xl">Other ways to reach us</h2>
            <div className="mt-4 space-y-3">
              <div className="flex items-center gap-2 text-stone-700">
                <Phone size={16} className="text-[color:var(--vv-teal)]" />
                <PhoneLink location="contact_body" />
              </div>
              <a href="mailto:info@vidavitalmedical.com" className="flex items-center gap-2 text-stone-700 hover:text-[color:var(--vv-teal)]">
                <Mail size={16} className="text-[color:var(--vv-teal)]" /> info@vidavitalmedical.com
              </a>
              <Link to="/locations" className="flex items-center gap-2 text-stone-700 hover:text-[color:var(--vv-teal)]">
                <MapPin size={16} className="text-[color:var(--vv-teal)]" /> View our five clinic locations
              </Link>
            </div>
          </div>
        </div>

        <aside className="space-y-4">
          <div className="vv-card p-6 bg-[color:var(--vv-ink)] text-white">
            <div className="text-[11px] uppercase tracking-widest text-[color:var(--vv-gold)]">Ready to book?</div>
            <div className="mt-2 text-lg font-display leading-snug">Request a consultation with a licensed provider.</div>
            <Link
              to="/request-consultation"
              data-testid="contact-request-consultation"
              className="mt-5 inline-flex w-full items-center justify-center rounded-full bg-[color:var(--vv-gold-deep)] text-white font-semibold px-6 py-3 text-sm uppercase tracking-widest hover:opacity-95 transition"
            >
              Request Consultation
            </Link>
            <div className="text-xs text-stone-300 mt-3">Every patient starts with a licensed medical provider evaluation.</div>
          </div>
        </aside>
      </section>
    </div>
  );
}
